"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var core_1 = require("../core");
exports.Column = styled_1.default(core_1.Flexbox)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
exports.Column.defaultProps = {
    flexDirection: "column",
    justifyContent: "center",
    flex: 1,
    margin: 2,
};
var templateObject_1;
